<template>
  <div class="c-history" v-if="history.items.length > 0">
    <div class="o-heading o-heading--bold o-heading--size-3 o-heading--section">
      {{ name }}
    </div>
    <div class="c-history__table-wrap" @scroll="loadMoreHistory">
      <table class="c-history__table o-table o-table--fixed">
        <thead>
          <tr class="c-history__row c-history__row--head">
            <th
              v-for="(value, name) in columns"
              :key="name.id"
              class="c-history__column-header"
            >
              <span>{{ value }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-for="item in history.items" :key="item.id">
          <tr tabindex="0" class="c-history__row" :class="item | eventToColor">
            <td class="c-history__item">
              {{ item.id }}
            </td>
            <td class="c-history__item">
              {{ item.created | formatDate("DD. MMM. YYYY - HH:mm") }}
            </td>
            <td class="c-history__item">
              {{ item.address }}
            </td>
            <td class="c-history__item">
              {{ item.accessConditions }}
            </td>
            <td class="c-history__item">
              {{ item.organizationCompany }}
            </td>
            <td class="c-history__item">
              {{ item.reportDescription }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { debounce } from "lodash";
export default {
  name: "c-history",
  data() {
    return {
      section: "history",
      name: "Historik",
      pageNo: 1,
      showModal: false,
      editModal: false,
      comment: null,
      editableComment: null,
      confirmation: false
    };
  },
  computed: {
    ...mapGetters("tip", [
      "parameters",
      "history",
      "aedData",
      "fadder",
      "status",
      "serviceProvider"
    ]),
    ...mapState("authentication", ["userInfo"]),
    ...mapState("tip", ["loading"]),
    ...mapState("translations", {
      translationsHistory: "otherReports",
      translationsCustom: "custom"
    }),
    columns() {
      let columns = {
        id: this.translationsHistory.id,
        createdDate: this.translationsHistory.created,
        address: this.translationsHistory.address,
        accessConditions: this.translationsHistory.accessConditions,
        organizationCompany: this.translationsHistory.organizationCompany,
        reportDescription: this.translationsHistory.reportDescription
      };
      return columns;
    }
  },
  methods: {
    loadMoreHistory: debounce(function(event) {
      if (
        event.target.scrollTop + event.target.offsetHeight >
          event.target.children[0].scrollHeight * 0.95 &&
        !this.loading &&
        this.history.pages > this.pageNo
      ) {
        const { dispatch } = this.$store;
        const payload = {
          api: this.$api,
          section: this.section,
          id: this.$store.state.aed.all.id,
          parameters: JSON.parse(JSON.stringify(this.parameters))
        };
        this.pageNo += 1;
        payload.parameters["pageNo"] = this.pageNo;
        dispatch("aed/getMoreHistory", payload);
      }
    }, 500),
    submitComment() {
      const payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: {
          comment: this.comment
        }
      };
      const { dispatch } = this.$store;

      if (this.editModal && this.editableComment.eventId) {
        payload["itemId"] = this.editableComment.eventId;
        if (this.confirmation) {
          dispatch("aed/deleteHistoryItem", payload);
        } else {
          dispatch("aed/patchHistoryItem", payload);
        }
      } else {
        dispatch("aed/unshiftItem", payload);
      }
      this.closeModal();
    },
    editComment(comment) {
      this.editModal = this.showModal = true;
      this.comment = comment.comment;
      this.editableComment = comment;
    },
    closeModal() {
      this.editModal = this.showModal = this.confirmation = false;
      this.comment = this.editableComment = null;
    },
    updateHistory() {
      const { dispatch } = this.$store;
      const payload = {
        api: this.$api,
        section: this.section,
        id: this.$store.state.aed.all.id,
        parameters: this.parameters
      };
      this.pageNo = 1;
      dispatch("aed/getSection", payload);
    }
  },
  watch: {
    aedData() {
      this.updateHistory();
    },
    fadder() {
      this.updateHistory();
    },
    status() {
      this.updateHistory();
    },
    serviceProvider() {
      this.updateHistory();
    }
  }
};
</script>
<style lang="scss">
.c-history {
  &__table-wrap {
    max-height: 345px;
    overflow: auto;
    margin-bottom: toRem(30px);
  }

  &__row {
    border-bottom: 1px solid #e6e6e6;

    &.o-status {
      &--green {
        background-color: $s-cp-sup-green-status;
      }
      &--pink {
        background-color: $s-cp-sup-pink-status;
      }
    }
    &--head {
      @include setStyles("13", $s-typography-sizes);
      background: $s-cp-neutral-800;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
        0 1px 2px 0 rgba(0, 0, 0, 0.15);
    }
  }

  &__column-header {
    padding: toRem(12px 14px);
    position: sticky;
    top: 0;
    background: $s-cp-neutral-800;
    @include setStyles("13", $s-typography-sizes);
    div,
    span {
      @include setStyles("13", $s-typography-sizes);
    }
  }

  &__column {
    &--type {
      width: 20%;
    }
    &--comment {
      width: 40%;
    }
    &--createdDate {
      width: 15%;
    }
    &--createdBy {
      width: 20%;
    }
    &--edit {
      width: 5%;
    }
  }

  &__item {
    padding: toRem(15px 14px);
    color: $s-cp-neutral-300;
    overflow-wrap: break-word;
    @include setStyles("13", $s-typography-sizes);

    div,
    span {
      @include setStyles("13", $s-typography-sizes);
    }

    &:first-child {
      font-weight: 700;
      color: $s-cp-main;
    }

    &--comment {
      span {
        margin: 0 5px 0 0;
        &:first-child {
          font-weight: 700;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &--edit {
      padding: toRem(0px 14px);
    }
  }
}
.c-modal-comment {
  &__text-area {
    resize: none;
    width: 100%;
    height: 165px;
  }

  &__note {
    margin: 15px 0 25px;
    color: $s-cp-neutral-400;
    @include setStyles("14", $s-typography-sizes);
  }
  &__footer-item {
    &--delete {
      margin-left: auto;

      .o-button {
        color: $s-cp-neutral-300;

        &__icon {
          fill: $s-cp-neutral-300;
        }
      }
    }
  }
}
</style>
